import { useDataChange } from 'Simple/Data.js'

export function useOnChangeSelectedRows(props) {
  let change = useDataChange({
    viewPath: props.viewPath,
    context: 'selected',
  })

  return function onChange(event) {
    change(next => {
      if (next.merged !== null) {
        if (!next.merged.downloaded) {
          if (
            !window.confirm(
              `You have a generated statement that was printed but not downloaded. Reselecting rows will clear it and you'll start over. Are you sure you want to do this?`
            )
          ) {
            return
          }
        } else if (!next.merged.printed) {
          if (
            !window.confirm(
              `You have a generated statement that was downloaded but not printed. Reselecting rows will clear it and you'll start over. Are you sure you want to do this?`
            )
          ) {
            return
          }
        }
      }

      if (next.merged?.url) {
        try {
          URL.revokeObjectURL(next.merged.url)
        } catch (_) {}
      }
      next.merged = null
      next.selected_rows = event.api.getSelectedNodes().map(item => item.data)
    })
  }
}
